import Auth from './auth.ts';
import API from './api.ts';
import Analytics from './analytics.ts';
import Storage from './storage.ts';


let config = {
    Auth: Auth,
    API: API,
    Analytics: Analytics,
    Cache: {
        capacityInBytes: 5242880, // 5MB, the max allowed value
        itemMaxSize: 2097152, // 2MB, max per item size
        defaultTTL: 2592000000, // 30 days
    },
    Storage: Storage,
};

export default config;
